import { Button, Container, Flex, Heading, ScrollArea, Table, Text } from "@radix-ui/themes";
import useFetch from "../../core/hooks/useFetch";
import SubjectRigthsService from '../../core/services/SubjectRightsService'
import { useEffect, useState } from "react";
import { ICompoundSubjectRights, ISubjectRights } from "../../core/types/services-types/subject-rights-types";
import {ArchiveIcon, ArrowTopRightIcon, Cross1Icon, CrossCircledIcon, PlusIcon, UpdateIcon} from '@radix-ui/react-icons'
import { Link, useNavigate,} from "react-router";
import { AUTHED_ROUTES } from "../../routes/constants";
import AppTable from "../../components/controls/tables/AppTable";
import {ToastContainer, toast} from 'react-toastify'
import CompoundSubjectRightsService from '../../core/services/CompoundSubjectRightsService'
import moment from "moment";
export default function SubjectRights() {
    const navigate = useNavigate()
    const [limit, setLimit] = useState(100)
    const [page, setPage] = useState(0)
    const [subjectRights, setSubjectRights] = useState<ISubjectRights[]>([])
    const [compoundSubjectRights, setCompoundSubjectRights] = useState<ICompoundSubjectRights[]>([])
    const [currentSubjectRights, setCurrentSubjectRights] = useState<ISubjectRights>()
    const [headersTable, setHeadersTable] = useState<any[]>(['ID', 'ID Субъекта права', "Название", "Дата", "Население", "Сумма бюджета", "Создано", "Обновлено", "Действия"])
    const [dataTable, setDataTable] = useState<any[][]>([])
    const [fetchSubjectRights, isLoading, error, errors] = useFetch(async () => {
        const data = await SubjectRigthsService.GetAll(limit, page)
        setSubjectRights(data)
        setCurrentSubjectRights(data[0])
    })

    const [fetchRemoveSubjectRights, isLoadingFetchRemoveSubjectRights, errorFetchRemoveSubjectRights, errorsFetchRemoveSubjectRights] = useFetch(async (id: number | string) => {
        await SubjectRigthsService.Remove(id)
        toast.success(`Субъект права с ${id} успешно удален!`)
    })

    const [fetchRemoveCompoundSubjectRights, isLoadingFetchRemoveCompoundSubjectRights, errorFetchRemoveCompoundSubjectRights, errorsFetchRemoveCompoundSubjectRights] = useFetch(async (id: number | string) => {
        await CompoundSubjectRightsService.Remove(id)
        toast.success(`Состав Субъека права с ${id} успешно удален!`)
    })

        const renderOption = (key: string, value: any) => {
            if(key === 'status') {
                if(value === 'created') {
                    return ( 
                    <Table.Cell>
                       <Text color='orange'> Создана </Text>
                        </Table.Cell>
                    )
                }
                if(value === 'success') {
                    return (
                        <Table.Cell>
                       <Text color="grass"> Подтверждена </Text>
                        </Table.Cell>
                    
                    )
                }
            }
            if(key === 'splitted') {
                if(value === true) {
                    return (
                       <Table.Cell>
                       <Text color="grass"> Да </Text>
                        </Table.Cell>
                    )
                }
                else {
                    return (
                        <Table.Cell>
                       <Text color="grass"> Нет </Text>
                        </Table.Cell>
                    )
                }
            }
            if(key === 'createdAt' || key === 'updatedAt') {
               return ( 
                <Table.Cell>
               { moment(value).format("DD.MM.YYYY HH:mm")}
                </Table.Cell>
               )
            }
            if(key === 'message') {
                if(value) {
                return (
                     <Table.Cell>
               {value.substring(0, 40)}...
                </Table.Cell>
                )
            }
            }
            return <Table.Cell>{value}</Table.Cell>
        }
    

    useEffect(() => {
        if(currentSubjectRights) {
        setCompoundSubjectRights(currentSubjectRights.compound_subject_rights)
        setDataTable([])
        currentSubjectRights.compound_subject_rights.map(item => {
            const actions = [
                "Действия",
                <Flex gap={'3'}>
                <Link to={AUTHED_ROUTES.COMPOUND_SUBJECT_RIGHTS_ACTIONS + `?id=${item.id}`}><Button variant='surface'><ArrowTopRightIcon /></Button></Link>
                <Button color="red" loading={isLoadingFetchRemoveCompoundSubjectRights} onClick={async () => fetchRemoveCompoundSubjectRights(item.id)}><CrossCircledIcon /></Button>
                </Flex>,
            ]
            setDataTable(prev => prev?.concat([Object.entries(item).concat([actions])]))
        })
        console.log(dataTable)
    }
    }, [currentSubjectRights])

    useEffect(() => {
        fetchSubjectRights()
    }, [])
    useEffect(() => {
        if(errorFetchRemoveSubjectRights) toast.error(errorFetchRemoveSubjectRights)
    }, [])
    return (
        <Container className="pt-10"> 
        <ToastContainer />
        <Flex className="p-5" gap={'5'} wrap={'wrap'}> 
        <Button onClick={() => navigate(AUTHED_ROUTES.SUBJECT_RIGHTS_ACTIONS)}>
        <PlusIcon /> Добавить Субъект права
        </Button>
        <Button onClick={() => navigate(AUTHED_ROUTES.COMPOUND_SUBJECT_RIGHTS_ACTIONS)}>
        <ArchiveIcon /> Добавить Состав Субъекта права
        </Button>
        </Flex>
        <Flex wrap={'wrap'} align={'start'}>
            <Container className="border"> 
            <Container> 
            <Heading className="heading p-5">Субъекты права</Heading>
            <hr />
            </Container>
            <ScrollArea type="always" scrollbars="both" style={{ height: 650 }} >
                {subjectRights.map(item => {
                    return (
                        <Flex className="border p-5" wrap={'wrap'} justify={'between'}>
                           <Flex wrap={'wrap'}>
                            <Text className="underline cursor-pointer" onClick={() => setCurrentSubjectRights(item)}>{item.id}.{item.name}</Text>
                            </Flex>
                            <Flex gap={'3'} className="pr-5">
                            <Button variant="solid" color="red" loading={isLoadingFetchRemoveSubjectRights} onClick={async () => fetchRemoveSubjectRights(item.id)}>
                                <Cross1Icon />
                            </Button>
                            <Button variant="solid" color="yellow" onClick={() => navigate(AUTHED_ROUTES.SUBJECT_RIGHTS_ACTIONS + `?id=${item.id}`)}>
                                <UpdateIcon />
                            </Button>
                           </Flex>
                        </Flex>
                    )
                })}
            </ScrollArea>
            </Container>
            <Container className="border mb-10">
                <Container> 
                <Heading className="p-5">Состав субъекта права "{currentSubjectRights?.name}"</Heading>
                <hr />
                </Container>
                    <ScrollArea type="always" scrollbars="both" style={{ height: 650 }} >
                    {dataTable.length ? 
                    <AppTable 
                    headers={headersTable}
                    data={dataTable}
                    renderOption={renderOption}
                    />
                    :
                    <Flex align={'center'} justify={'center'}>
                        <Text>Данных нет</Text>
                    </Flex>
                    
                    }
                    </ScrollArea>
                 
            </Container>
        </Flex>
        </Container>
    )
}